module.exports = Promise.resolve(module.bundle.root("LY8bf"))